
<template>
        <b-modal :active="true" :width="400" :can-cancel="false" scroll="keep">
            <form @submit.prevent="submit">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{$t('students.profile.references.delete.modalTitle')}}</p>
                    </header>

                    <section class="modal-card-body">
                        <p class="has-text-centered">{{$t('students.profile.references.delete.warning')}}</p>
                    </section>

                    <footer class="modal-card-foot content-pulled-center">
                        <button class="button" type="button" @click="cancel">{{$t('global.actions.cancel')}}</button>

                        <button class="button is-danger" :class="{'is-loading': isSubmitting}">{{$t('global.actions.delete')}}</button>
                    </footer>
                </div>
            </form>
        </b-modal>
</template>

<script>
    import ReferenceService from '@/taskflex/students/services/ReferenceService';

    export default {
        data() {
            return {
                isSubmitting: false,
            };
        },

        props: {
            reference: {
                type: Object,
                required: true,
            },
        },

        methods: {
            cancel() {
                this.$emit('cancel');
            },

            submit() {
                ReferenceService.remove(this.reference.student_id, this.reference.id, () => {
                    this.isSubmitting = false;
                    this.$emit('deleted');
                }, () => {
                    this.isSubmitting = false;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/references/DeleteReference.vue